// extracted by mini-css-extract-plugin
export default {"range_sec":"Table_range_sec__Axk-s","range_head":"Table_range_head__kDWlC","plus_btn":"Table_plus_btn__X2IeF","range_table":"Table_range_table__uW0lS"};